// app.js
import "App.css"
import React, { useState, useEffect } from "react"
import Routes from "routes"
import ThemeCustomization from "themes"
import ScrollTop from "components/ScrollTop"
import { useSelector } from "react-redux"
import Loader from "components/Loader"
import useLoadRequiredData from "hooks/LoadRequireData"
import Contextswrapper from "Contextswrapper"
const App = () => {
  const { isLogin, user } = useSelector((state) => state.user)

  const isLoading = useSelector((state) =>
    Object.values({ ...state.api.queries, ...state.api.mutations }).some(
      (query) => query.status === "pending"
    )
  )

  const loadRequireData = useLoadRequiredData()
  loadRequireData()
  return (
    <>
      <ThemeCustomization>
        <Contextswrapper>
          <ScrollTop>
            {isLoading && <Loader />}
            <Routes isAuthenticated={isLogin} />
          </ScrollTop>
        </Contextswrapper>
      </ThemeCustomization>
    </>
  )
}

export default App
